import styled from "@emotion/styled";
import { createTheme, Switch, ThemeProvider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

import SubscriptionPlanCard from "./SubscriptionPlanCardjs";
import FullWidthTabs from "./SubscriptionTabs";

import "react-multi-carousel/lib/styles.css";
import { useTranslation } from "react-i18next";

//md breakpoint change for responsive layout in cards
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1536,
    },
  },
});
// const MaterialUISwitch = styled(Switch)(({ theme }) => ({
//   width: 140,
//   height: 33,
//   padding: 2,

//   "& .MuiSwitch-switchBase": {
//     padding: 0,
//     transform: "translateX(1px)",

//     "&.Mui-checked": {
//       transform: "translateX(62px)",

//       "& .MuiSwitch-thumb": {
//         background:
//           "linear-gradient(49deg, rgba(252,242,24,1) 16%, rgba(255,180,110,1) 100%)",
//       },

//       "& .MuiSwitch-thumb:before": {
//         backgroundImage: `url('data:image/svg+xml,<%3Fxml version="1.0" encoding="iso-8859-1"%3F><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" viewBox="0 0 416.449 416.449" xml:space="preserve" width="20" height="20"><g id="_x31_5._Rocket_2_"><g id="XMLID_65_"><g><g><path style="fill:%23FF7124;" d="M399.76,16.699c10.12,37.84,8.67,78.13-4.34,115.28h-0.01L284.48,21.049v-0.01 C321.63,8.029,361.92,6.579,399.76,16.699z"/></g><g><path style="fill:%23F2D59F;" d="M90.21,207.929l87.14-101.42h0.01l33.71-39.24c21.43-21.43,46.6-36.84,73.41-46.23v0.01 l110.93,110.93h0.01c-9.39,26.81-24.8,51.98-46.23,73.41l-39.24,33.71l-101.43,87.14l-29.57-29.57l-29.58-29.58l-29.58-29.58 L90.21,207.929z M296.11,193.399c20.18-20.17,20.18-52.89,0-73.06c-20.17-20.18-52.89-20.18-73.06,0 c-20.18,20.17-20.18,52.89,0,73.06C243.22,213.579,275.94,213.579,296.11,193.399z"/></g><g><path style="fill:%23F2D59F;" d="M309.95,239.099c1.74,45.6-14.8,91.78-49.61,126.59c-10.69,10.68-22.44,19.65-34.93,26.89 l-16.89-66.34L309.95,239.099z"/></g><g><path style="fill:%238ECAC1;" d="M296.11,120.339c20.18,20.17,20.18,52.89,0,73.06c-20.17,20.18-52.89,20.18-73.06,0 c-20.18-20.17-20.18-52.89,0-73.06C243.22,100.159,275.94,100.159,296.11,120.339z"/></g><g><path style="fill:%23E6B263;" d="M208.52,326.239l-39.94,14.71c-10.98,4.05-23.31,1.34-31.58-6.94l-6.85-6.85l48.8-30.49 L208.52,326.239z"/></g><g><polygon style="fill:%23E6B263;" points="178.95,296.669 130.15,327.159 130.14,327.159 109.72,306.739 149.37,267.089 "/></g><g><path style="fill:%23F2D59F;" d="M177.35,106.509l-87.14,101.42l-66.33-16.88c7.24-12.49,16.21-24.24,26.89-34.93 C85.58,121.309,131.74,104.769,177.35,106.509z"/></g><g><polygon style="fill:%23E6B263;" points="149.37,267.089 109.72,306.739 89.3,286.309 119.79,237.509 "/></g><g><path style="fill:%23E6B263;" d="M119.79,237.509l-30.49,48.8l-6.86-6.85c-8.27-8.28-10.98-20.6-6.94-31.58l14.71-39.95 L119.79,237.509z"/></g></g><g><g><path style="fill:%235E2A41;" d="M28.88,339.459c-2.559,0-5.119-0.977-7.071-2.929c-3.905-3.905-3.905-10.237,0-14.143 l20.54-20.54c3.905-3.904,10.237-3.904,14.143,0c3.905,3.905,3.905,10.237,0,14.143l-20.54,20.54 C33.999,338.482,31.44,339.459,28.88,339.459z"/></g><g><path style="fill:%235E2A41;" d="M10,416.439c-2.56,0-5.119-0.977-7.072-2.93c-3.905-3.905-3.904-10.237,0.001-14.142l68.47-68.46 c3.905-3.904,10.237-3.904,14.142,0.001c3.905,3.905,3.904,10.237-0.002,14.142l-68.47,68.46 C15.118,415.463,12.559,416.439,10,416.439z"/></g><g><path style="fill:%235E2A41;" d="M73.29,411.259c-2.56,0-5.118-0.977-7.071-2.929c-3.905-3.905-3.905-10.237,0-14.143 l34.23-34.229c3.905-3.904,10.237-3.903,14.142,0c3.905,3.905,3.905,10.237,0,14.143l-34.23,34.229 C78.409,410.282,75.849,411.259,73.29,411.259z"/></g><g><path style="fill:%235E2A41;" d="M208.52,336.239c-2.56,0-5.118-0.977-7.071-2.929L83.139,215c-3.905-3.905-3.905-10.237,0-14.143 c3.905-3.904,10.237-3.904,14.143,0l118.31,118.311c3.905,3.905,3.905,10.237,0,14.143 C213.639,335.263,211.079,336.239,208.52,336.239z"/></g><g><path style="fill:%235E2A41;" d="M259.58,218.534c-16.474,0-31.959-6.416-43.604-18.066c-11.646-11.641-18.062-27.126-18.062-43.6 c0-16.474,6.416-31.959,18.065-43.604c11.641-11.646,27.126-18.062,43.6-18.062s31.959,6.416,43.604,18.065 c11.645,11.641,18.061,27.126,18.061,43.6c0,16.472-6.415,31.956-18.061,43.6l0,0c-0.001,0.002-0.001,0.001-0.004,0.004 C291.536,212.119,276.052,218.534,259.58,218.534z M259.58,115.204c-11.13,0-21.592,4.334-29.457,12.204 c-7.874,7.869-12.208,18.331-12.208,29.461s4.334,21.592,12.204,29.457c7.869,7.874,18.331,12.208,29.461,12.208 c11.13,0,21.592-4.334,29.457-12.204c0.002-0.001,0.003-0.002,0.004-0.004c7.87-7.865,12.204-18.327,12.204-29.457 s-4.334-21.592-12.204-29.457C281.172,119.538,270.71,115.204,259.58,115.204z"/></g><g><path style="fill:%235E2A41;" d="M89.291,296.31c-1.81,0-3.642-0.49-5.29-1.521c-4.684-2.926-6.108-9.096-3.182-13.779l30.49-48.8 c2.927-4.684,9.097-6.11,13.78-3.182c4.684,2.926,6.108,9.096,3.182,13.779l-30.49,48.8 C95.884,294.643,92.625,296.31,89.291,296.31z"/></g><g><path style="fill:%235E2A41;" d="M109.72,316.739c-2.559,0-5.118-0.977-7.071-2.929c-3.905-3.905-3.906-10.237-0.001-14.143 l39.65-39.65c3.905-3.904,10.237-3.904,14.142,0c3.905,3.905,3.906,10.237,0.001,14.142l-39.65,39.65 C114.839,315.763,112.279,316.739,109.72,316.739z"/></g><g><path style="fill:%235E2A41;" d="M130.16,337.16c-3.334,0-6.593-1.666-8.49-4.702c-2.926-4.684-1.501-10.854,3.182-13.779 l48.8-30.49c4.683-2.929,10.853-1.503,13.78,3.182c2.926,4.684,1.501,10.853-3.182,13.779l-48.8,30.49 C133.801,336.67,131.97,337.16,130.16,337.16z"/></g><g><path style="fill:%235E2A41;" d="M177.356,116.509c-2.307,0-4.625-0.794-6.512-2.415c-4.189-3.599-4.668-9.912-1.069-14.102 l33.71-39.24c3.598-4.188,9.911-4.668,14.102-1.068c4.189,3.599,4.668,9.912,1.068,14.101l-33.71,39.24 C182.968,115.327,180.17,116.509,177.356,116.509z"/></g><g><path style="fill:%235E2A41;" d="M158.265,352.787c-10.448,0-20.723-4.085-28.34-11.712l-6.582-6.582 c-0.093-0.086-0.184-0.173-0.273-0.263l-47.694-47.695c-10.992-11.006-14.623-27.531-9.259-42.109l14.71-39.952 c0.413-1.12,1.022-2.157,1.799-3.061l87.14-101.42c3.601-4.188,9.913-4.667,14.102-1.068c4.189,3.6,4.667,9.913,1.068,14.102 L98.971,213.077l-14.086,38.257c-2.682,7.289-0.864,15.556,4.632,21.059l47.432,47.433c0.092,0.086,0.184,0.173,0.273,0.263 l6.85,6.85c5.497,5.504,13.756,7.318,21.048,4.63l38.252-14.089l139.302-119.675c4.191-3.6,10.504-3.119,14.102,1.068 c3.6,4.189,3.121,10.503-1.068,14.102L215.036,333.824c-0.904,0.777-1.94,1.387-3.059,1.799l-39.941,14.71 C167.557,351.985,162.893,352.787,158.265,352.787z"/></g><g><path style="fill:%235E2A41;" d="M349.19,215.389c-2.559,0-5.118-0.977-7.071-2.929c-3.905-3.905-3.905-10.237,0-14.143 c19.885-19.884,34.642-43.315,43.863-69.644c11.736-33.512,13.626-69.25,5.536-103.733c-34.48-8.089-70.221-6.199-103.733,5.536 c-26.329,9.221-49.761,23.979-69.645,43.863c-3.905,3.904-10.236,3.905-14.143,0c-3.905-3.905-3.905-10.237,0-14.143 c22.025-22.024,47.991-38.375,77.176-48.596C320.331-2.111,362.231-3.69,402.344,7.039c3.454,0.924,6.152,3.622,7.076,7.076 c10.728,40.114,9.151,82.014-4.563,121.17c-10.221,29.185-26.571,55.15-48.596,77.175 C354.309,214.412,351.75,215.389,349.19,215.389z"/></g><g><path style="fill:%235E2A41;" d="M395.41,141.98c-2.56,0-5.118-0.977-7.071-2.929L277.409,28.12 c-3.905-3.905-3.905-10.237,0-14.143c3.908-3.905,10.238-3.903,14.143,0l110.93,110.931c3.905,3.905,3.905,10.237,0,14.143 C400.528,141.003,397.969,141.98,395.41,141.98z"/></g><g><path style="fill:%235E2A41;" d="M90.22,217.929c-0.832,0-1.67-0.104-2.477-0.309l-66.33-16.88 c-3.037-0.773-5.537-2.926-6.751-5.814c-1.215-2.889-1.005-6.181,0.566-8.892c7.778-13.418,17.355-25.86,28.467-36.982 c35.281-35.281,84.119-54.445,133.988-52.537c5.369,0.176,9.671,4.583,9.671,9.994c0,5.522-4.472,10-9.995,10h-0.01 c-0.127,0-0.254-0.002-0.381-0.007c-44.338-1.699-87.765,15.325-119.127,46.688c-6.684,6.689-12.742,13.914-18.101,21.576 l52.73,13.419c4.435,1.024,7.745,4.998,7.745,9.743C100.215,213.451,95.743,217.929,90.22,217.929z"/></g><g><path style="fill:%235E2A41;" d="M225.41,402.579c-1.315,0-2.633-0.259-3.876-0.782c-2.89-1.215-5.042-3.714-5.815-6.75 l-16.891-66.34c-1.363-5.353,1.872-10.796,7.224-12.158c5.349-1.366,10.795,1.871,12.158,7.223l13.48,52.948 c7.663-5.359,14.889-11.419,21.581-18.104c31.36-31.36,48.378-74.785,46.684-119.136c-0.21-5.519,4.093-10.163,9.611-10.374 c5.509-0.233,10.164,4.093,10.375,9.611c1.903,49.897-17.243,98.755-52.532,134.044c-11.124,11.113-23.567,20.691-36.986,28.47 C228.881,402.126,227.148,402.579,225.41,402.579z"/></g></g></g></g></svg>')`,
//       },
//       "& + .MuiSwitch-track": {
//         opacity: 1,
//         background:
//           theme.palette.mode === "dark"
//             ? "red"
//             : "linear-gradient(49deg, rgba(252,242,24,1) 0%, rgba(255,255,255,1) 51%, rgba(245,245,248,1) 56%, rgba(69,248,255,1) 100%)",
//       },
//     },
//   },
//   "& .MuiSwitch-thumb": {
//     background:
//       "linear-gradient(49deg, rgba(110,162,255,1) 5%,rgba(164,255,176,1) 80% )",
//     width: 70,
//     borderRadius: "5rem",
//     height: 25,

//     display: "inline-block",
//     marginTop: "0.2rem",
//     outline: "2px solid whitesmoke",
//     outlineOffset: "-2px",

//     boxShadow: "1px 1px 4px 1px #000000",
//     "&:before": {
//       content: "''",
//       position: "absolute",
//       width: "100%",
//       height: "100%",

//       left: 0,
//       top: 0,
//       backgroundRepeat: "no-repeat",
//       backgroundPosition: "center",

//       backgroundImage: `url('data:image/svg+xml,<%3Fxml version="1.0" encoding="iso-8859-1"%3F><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --><svg height="30px" width="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"><g><path style="fill:%2329ABE2;" d="M501.801,404.137c0-61.929-48.753-112.466-109.972-115.337c40.268,22.679,67.47,65.828,67.47,115.337L501.801,404.137z"/><path style="fill:%2329ABE2;" d="M342.291,270.175c1.002,1.02,2.04,2.004,3.11,2.953c16.43,2.286,31.892,7.586,45.813,15.329c31.802-2.493,56.837-29.069,56.837-61.511c0-33.547-26.77-60.824-60.111-61.681c6.206,10.518,9.781,22.776,9.781,35.873C397.721,234.942,373.995,263.187,342.291,270.175z"/><path style="fill:%2329ABE2;" d="M325.515,216.462c2.473-5.352,4.35-11.036,5.537-16.969C328.428,204.765,326.541,210.466,325.515,216.462z"/><path style="fill:%2329ABE2;" d="M52.701,404.137c0-49.509,27.201-92.658,67.47-115.337c-61.219,2.871-109.972,53.408-109.972,115.337H52.701z"/><path style="fill:%2329ABE2;" d="M169.709,270.175c-31.703-6.987-55.43-35.233-55.43-69.036c0-13.097,3.575-25.354,9.781-35.873c-33.341,0.857-60.111,28.132-60.111,61.681c0,32.442,25.035,59.019,56.837,61.511c13.921-7.743,29.383-13.044,45.813-15.329C167.669,272.179,168.707,271.195,169.709,270.175z"/><path style="fill:%2329ABE2;" d="M180.948,199.492c1.187,5.934,3.064,11.617,5.537,16.969C185.459,210.466,183.572,204.765,180.948,199.492z"/></g><g><path style="fill:%23BDCCD4;" d="M186.485,216.462c-2.473-5.352-4.35-11.036-5.537-16.969c-0.976-4.878-1.489-9.924-1.489-15.09c0-20.243,7.873-38.638,20.705-52.326c-4.891-1.07-9.964-1.65-15.175-1.65c-25.955,0-48.631,13.993-60.93,34.838c-6.206,10.518-9.781,22.776-9.781,35.873c0,33.803,23.726,62.05,55.43,69.036c4.923,1.085,10.032,1.675,15.281,1.675c16.811,0,32.243-5.878,44.378-15.675C210.367,249.121,194.93,234.738,186.485,216.462z"/><path style="fill:%23BDCCD4;" d="M120.785,288.457c-0.205,0.114-0.41,0.228-0.615,0.344C79.902,311.48,52.7,354.628,52.7,404.137h60.105c0-43.753,19.637-82.905,50.563-109.169c10.735-9.116,22.821-16.691,35.931-22.351c-4.701-0.506-9.474-0.769-14.309-0.769c-6.242,0-12.38,0.443-18.391,1.279C150.169,275.413,134.706,280.715,120.785,288.457z"/><path style="fill:%23BDCCD4;" d="M391.829,288.801c-0.205-0.115-0.409-0.229-0.615-0.344c-13.921-7.743-29.383-13.044-45.813-15.329c-6.011-0.836-12.149-1.279-18.391-1.279c-4.835,0-9.609,0.263-14.309,0.769c13.11,5.66,25.195,13.234,35.931,22.351c30.926,26.264,50.563,65.417,50.563,109.169h60.105C459.299,354.629,432.097,311.481,391.829,288.801z"/><path style="fill:%23BDCCD4;" d="M397.721,201.139c0-13.097-3.575-25.354-9.781-35.873c-12.299-20.845-34.975-34.838-60.93-34.838c-5.212,0-10.285,0.58-15.175,1.65c12.833,13.688,20.705,32.083,20.705,52.326c0,5.166-0.513,10.211-1.489,15.09c-1.187,5.934-3.064,11.617-5.537,16.969c-8.445,18.276-23.88,32.659-42.882,39.713c12.135,9.797,27.566,15.675,44.378,15.675c5.25,0,10.358-0.59,15.281-1.675C373.995,263.187,397.721,234.942,397.721,201.139z"/></g><g><polygon style="fill:%2329ABE2;" points="317.278,404.137 194.722,404.137 112.805,404.137 112.805,404.137 399.195,404.137 399.195,404.137 "/><path style="fill:%2329ABE2;" d="M312.701,272.618c-17.389-7.507-36.557-11.674-56.701-11.674c-20.144,0-39.312,4.167-56.701,11.674c-50.879,21.965-86.493,72.58-86.493,131.52h81.917h122.556h81.917C399.195,345.197,363.58,294.583,312.701,272.618z"/><path style="fill:%2329ABE2;" d="M332.54,184.403c0-20.243-7.873-38.638-20.705-52.326c-13.965-14.895-33.806-24.215-55.836-24.215s-41.871,9.319-55.836,24.215c-12.833,13.688-20.705,32.083-20.705,52.326c0,32.905,20.768,60.954,49.908,71.772c8.295,3.079,17.266,4.769,26.633,4.769s18.337-1.689,26.633-4.769C311.773,245.356,332.54,217.308,332.54,184.403z"/></g><path d="M427.935,285.555c18.327-13.048,30.316-34.448,30.316-58.61c0-37.168-28.34-67.84-64.545-71.544c-14.6-21.224-39.046-35.174-66.696-35.174c-4.007,0-7.941,0.311-11.792,0.879c-15.516-14.524-36.34-23.443-59.219-23.443c-22.877,0-43.7,8.917-59.214,23.44c-3.853-0.567-7.789-0.875-11.796-0.875c-27.651,0-52.097,13.949-66.696,35.174c-36.205,3.705-64.545,34.377-64.545,71.544c0,24.161,11.988,45.561,30.316,58.61C35.157,302.765,0,349.42,0,404.137c0,5.633,4.566,10.199,10.199,10.199h42.502h1.354h57.116v-0.143c0.533,0.086,1.077,0.143,1.635,0.143h286.389c0.207,0,0.41-0.018,0.615-0.031v0.031h56.096h3.394h42.501c5.633,0,10.199-4.566,10.199-10.199C512,349.42,476.843,302.765,427.935,285.555z M437.853,226.947c0,26.078-19.48,47.679-44.652,51.05c-6.952-3.663-14.237-6.772-21.804-9.259c21.979-14.481,36.524-39.368,36.524-67.599c0-7.725-1.111-15.191-3.142-22.272C424.099,186.301,437.853,205.038,437.853,226.947z M387.523,201.137c0,33.367-27.145,60.512-60.512,60.512c-8.32,0-16.248-1.695-23.468-4.751c23.586-15.52,39.198-42.212,39.198-72.497c0-15.904-4.321-30.808-11.823-43.636C362.467,142.788,387.523,169.085,387.523,201.137z M322.341,184.403c0,36.58-29.76,66.341-66.341,66.341s-66.341-29.76-66.341-66.341s29.76-66.341,66.341-66.341S322.341,147.822,322.341,184.403z M181.084,140.766c-7.502,12.829-11.823,27.734-11.823,43.636c0,30.283,15.611,56.976,39.197,72.496c-7.219,3.056-15.147,4.751-23.467,4.751c-33.367,0-60.512-27.145-60.512-60.512C124.477,169.085,149.533,142.788,181.084,140.766z M74.147,226.947c0-21.912,13.753-40.662,33.078-48.094c-2.034,7.085-3.146,14.556-3.146,22.286c0,28.232,14.545,53.118,36.524,67.599c-7.567,2.487-14.852,5.597-21.804,9.259C93.628,274.626,74.147,253.025,74.147,226.947z M77.759,310.421c-19.842,22.67-32.624,51.661-34.888,83.517H20.888C24.409,357.484,46.603,326.412,77.759,310.421z M102.954,393.938H63.322c4.501-54.16,44.511-98.39,96.621-109.299C127.488,310.78,105.864,349.841,102.954,393.938z M123.392,393.938C128.62,325.355,186.099,271.143,256,271.143s127.38,54.212,132.608,122.795H123.392z M409.046,393.938c-2.91-44.097-24.534-83.158-56.989-109.299c52.11,10.909,92.12,55.139,96.621,109.299H409.046z M469.13,393.938c-2.263-31.846-15.039-60.828-34.869-83.495c31.143,15.994,53.332,47.05,56.85,83.495L469.13,393.938L469.13,393.938z"/><path d="M193.656,297.106c-27.942,16.693-48.311,44.341-55.883,75.855c-1.317,5.477,2.057,10.984,7.534,12.3c0.801,0.193,1.602,0.285,2.392,0.285c4.607,0,8.785-3.143,9.909-7.819c6.298-26.211,23.251-49.213,46.511-63.109c4.835-2.889,6.414-9.151,3.526-13.986C204.754,295.794,198.491,294.218,193.656,297.106z"/><path d="M255.857,279.987c-9.507,0-18.975,1.104-28.143,3.28c-5.481,1.3-8.869,6.799-7.568,12.279c1.113,4.689,5.296,7.846,9.915,7.846c0.78,0,1.573-0.09,2.364-0.278c7.626-1.81,15.51-2.728,23.432-2.728c5.633,0,10.199-4.566,10.199-10.199C266.056,284.553,261.49,279.987,255.857,279.987z"/></svg>')`,
//     },
//   },
//   "& .MuiSwitch-track": {
//     opacity: 1,
//     height: 30,
//     transition: "1s ease",
//     width: 130,
//     // backgroundColor: theme.palette.mode === "dark" ? "red" : "grey",
//     boxShadow: "inset 0px 0px 5px 2px #242003",
//     background:
//       theme.palette.mode === "dark"
//         ? "red"
//         : "linear-gradient(49deg, rgba(252,242,24,1) 0%, rgba(255,255,255,1) 51%, rgba(245,245,248,1) 56%, rgba(69,248,255,1) 100%)",
//     borderRadius: 66 / 2,
//   },
// }));

const SimplePlanSwitch = styled(Switch)(({ theme }) => ({
  width: 400,
  height: 50,
  padding: 2,

  "& .MuiSwitch-switchBase": {
    padding: 0,
    transform: "translateX(10px)",
    transition: "1s ease",

    "&.Mui-checked": {
      transform: "translateX(205px)",
      "& .MuiSwitch-thumb": {
        // background: "navy",
        // background:
        //   "linear-gradient(49deg, rgba(252,242,24,1) 16%, rgba(255,180,110,1) 100%)",
      },

      "& .MuiSwitch-thumb:before": {
        content: "'Individual '",
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        background: "whitesmoke",
        // background:
        //   theme.palette.mode === "dark"
        //     ? "red"
        //     : "linear-gradient(49deg, rgba(252,242,24,1) 0%, rgba(255,255,255,1) 51%, rgba(245,245,248,1) 56%, rgba(69,248,255,1) 100%)",
      },
    },
  },
  "& .MuiTouchRipple-root": {
    display: "inline-block",
    height: 30,
    top: 11,
    borderRadius: "5rem",
    width: 185,
    mt: "0.1rem",
  },
  "& .MuiSwitch-thumb": {
    // background:
    //   "linear-gradient(49deg, rgba(110,162,255,1) 5%,rgba(164,255,176,1) 80% )",
    // background: "red",
    outline: "2px solid whitesmoke",
    outlineOffset: "-2px",
    width: 185,
    borderRadius: "5rem",
    height: 30,
    display: "inline-block",
    marginTop: "0.6rem",
    boxShadow: 3,
    background: "rgb(179, 235, 255)",
    "&:before": {
      marginTop: "0.1rem",
      content: "'Group'",
      display: "flex",
      fontSize: "1.1rem",

      color: "black",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      width: "100%",
      height: "100%",

      left: 0,
      top: 0,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    height: 47,
    transition: "1s ease",
    "&:before": {
      content: "'Group'",
      position: "absolute",
      left: "15%",
      top: 12,
      mt: "0.1rem",
      fontSize: "1.1rem",
      color: "grey",
    },
    "&:after": {
      content: "'Individual'",
      position: "absolute",
      right: "13%",
      top: 12,
      fontSize: "1.1rem",
      color: "grey",
    },
    width: 395,
    // backgroundColor: theme.palette.mode === "dark" ? "red" : "grey",

    // boxShadow: "inset 0px 0px 2px 1px #242003",
    background: "whitesmoke",
    // background:
    //   theme.palette.mode === "dark"
    //     ? "red"
    //     : "linear-gradient(49deg, rgba(252,242,24,1) 0%, rgba(255,255,255,1) 51%, rgba(245,245,248,1) 56%, rgba(69,248,255,1) 100%)",
    borderRadius: 66 / 2,
  },
}));
function SwitchLayout(props) {
  const {
    planFrontend,
    planFrontendStatus,
    title,
    planFrontend1,
    planFrontendStatus1,
    containerClass,
  } = props;
  const [checked, setChecked] = React.useState(false);
  const handleChange = (event) => {
    setChecked(event.target.checked);
    // checked === true ? setToggle(1) : setToggle(0);
  };
  const { i18n } = useTranslation();

  // Get the current language
  const currentLanguage = i18n.language;

  localStorage.setItem("backToPath", "/");

  //custom css and responsive value
  const hStyle = {
    fontSize: {
      xs: "16px",
      sm: "17px",
      md: "1.7rem",
    },
    fontWeight: 600,
    pt: "1rem",
    pb: "1rem",
    textAlign: "center",
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        {/* subscripiont box start */}
        <Box
          pb={5}
          sx={{
            width: {
              md: "100%",
              xl: "100%",
            },
            mx: "auto",
            //  backgroundImage: `url(${process.env.REACT_APP_FRONTEND_URL}Image/banner_tg.png)`,
            //       // backgroundPosition: "center",
            //       backgroundSize: "cover",
            //       position: "relative", // Anchor absolute children
            //       overflow: "hidden", // Prevent scrolling
          }}
        >
          {/* <subscription title */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              border: "1px solid gray",
              flexDirection: "column",

              padding: "10px",
              alignItems: "center",
              width: "45%",
              borderRadius: "2rem",
              boxShadow: "inset 0px 0px 2px 1px #242003",
              backgroundColor: "rgb(227,242,253)",
              margin: "2rem auto",
            }}
          >
            <Typography variant="h3" sx={{ ...hStyle, color: "#000" }}>
              {title}
            </Typography>
            <SimplePlanSwitch
              checked={checked}
              onChange={handleChange}
              sx={{
                transform: {
                  xs: "scale(0.7)",
                  sm: "scale(1)",
                },
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            />
            <Box
              sx={{
                display: {
                  xs: "block",
                  md: "none",
                },
              }}
            >
              <Typography sx={{ textAlign: "center" }}>
                {checked ? "Individual" : "Group"}
              </Typography>
              <Switch checked={checked} onChange={handleChange} name="" />
            </Box>
          </Box>

          {!checked && (
            <SubscriptionPlanCard
              planFrontend={planFrontend}
              planFrontendStatus={planFrontendStatus}
              containerClass={containerClass}
              // planType={1}
            ></SubscriptionPlanCard>
          )}

          {checked &&
            (title === "Subscription" ? (
              <Box sx={{ my: 2 }}>
                <FullWidthTabs></FullWidthTabs>
              </Box>
            ) : (
              <SubscriptionPlanCard
                planFrontend={planFrontend1}
                planFrontendStatus={planFrontendStatus1}
                // planType={2}
              ></SubscriptionPlanCard>
            ))}
        </Box>
        {/* subscripiont box end */}
      </ThemeProvider>
    </>
  );
}

export default SwitchLayout;
